import Card from 'components/Card';
import styled from 'styled-components';

const StyledCard = styled(Card)`
    height: calc(100vh - 161px);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
`;

export default StyledCard;
